import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {appConstants} from "../../../constants";
import {PopupHelperService} from "../../../core/services/popup-helper.service";
import {FriendService} from "../../../core/services/friend.service";
import {EventManagerService} from '../../../core/services/event-manager.service';
import {MeService} from "../../../core/services/me.service";
import {DisputeService} from "../../../core/services/dispute.service";
import {ModalComponent} from "../modal/modal.component";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {ParticipateService} from "../../../core/services/participate.service";
import {NotificationService} from "../../../core/services/notification.service";
import {PublisherSettingsService} from "../../../core/services/publisher/publisher-settings-service";
import {Router} from "@angular/router";
import {customSetInterval, customSetTimeout} from "../../../core/helpers/overrided-timers";
import {AsyncPipe, DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {
  TeamInvitationWidgetItemComponent
} from "../../widget/event-bar/items/team-invitation-widget-item/team-invitation-widget-item.component";
import {TicketComponent} from "../ticket/tournament/ticket.component";
import {TimerPipe} from "../../pipes/timer.pipe";
import {PrimaryButtonComponent} from "../primary-button/primary-button.component";
import {SecondaryButtonComponent} from "../secondary-button/secondary-button.component";


@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  standalone: true,
  imports: [
    NgClass,
    DatePipe,
    TeamInvitationWidgetItemComponent,
    TranslateModule,
    TicketComponent,
    NgForOf,
    NgIf,
    TimerPipe,
    AsyncPipe,
    PrimaryButtonComponent,
    SecondaryButtonComponent
  ],
  providers: [
    FriendService,
    PopupHelperService,
    EventManagerService,
    ParticipateService,
    PublisherSettingsService,
    MeService,
    DisputeService,
    TranslateService,
    NotificationService
  ],
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent implements OnInit {

  @Input() notification: any;
  @Input() openInModal: boolean = false;
  @Input() showRemove: boolean = true;
  @Input() class: string = '';
  @Input() opened: boolean = false;
  @ViewChild('NotificationModal') NotificationModal: any
  @Output()openModal: EventEmitter<any>;
  @Output()closeNotifayModal: EventEmitter<any>;
  @Output()closeNotifyWidget: EventEmitter<any>;
  date: any
  types: any = appConstants.NOTIFICATIONTYPES;
  answersFriendReq: any = {
    ACCEPTED: 'accepted',
    DECLINED: 'declined',
  }
  errorMessage:any
  NotificationStatus: any = appConstants.NotificationStatus
  disputeOne: any
  modalNotification: any
  dateNowNumber:any
  public index: number =0 ;

  constructor(private friendService: FriendService,
              private popupHelperService: PopupHelperService,
              private eventManagerService:EventManagerService,
              private participantService:ParticipateService,
              private router:Router,
              private publisherSettings:PublisherSettingsService,
              private meService: MeService,
              private disputeService: DisputeService,
              private translateService: TranslateService,
              private notificationService: NotificationService) {
    this.openModal = new EventEmitter<any>();
    this.closeNotifayModal = new EventEmitter<any>();
    this.closeNotifyWidget = new EventEmitter<any>();
  }

  ngOnInit(): void {
    customSetInterval(()=>{
      this.dateNowNumber = Date.now()
    }, 1000)

    if(this.notification && this.notification.type === this.types.ANSWER_FOR_DISPUTE){
      this.getDispute()
    }
    customSetTimeout(() => {
      if(this.opened){
        this.openPopupSeen(this.notification);
      }
    });
    let interval = this.getDifferenceInMinutes(new Date(),new Date(this.notification.createdAt))
    if(interval < 60){
      this.date = parseInt(interval.toString()) + ' ' + this.translateService.instant('min_ago')
    }

  }

  getDifferenceInMinutes(date1:any, date2: any) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60);
  }

  stringAsDate(dateStr: string) {
    return new Date(dateStr);
  }
  answerFriendReq(status: string){
    this.friendService.answerInvitationByNotify(this.notification._id, {status: status}).subscribe((data:any) => {

      if (!data.hasError) {
        this.popupHelperService.printSuccess()
        if(status === this.answersFriendReq.ACCEPTED){
          this.notification.status = this.NotificationStatus.ACCEPTED
        }else {
          this.notification.status = this.NotificationStatus.CANCELED
        }
      } else {
        this.errorMessage = data.errorMessages[0].msg;
        this.popupHelperService.printError({text:this.errorMessage});
      }
    })
   }
  closeMenu(){
    this.eventManagerService.menuTrigger.emit(-1);
  }

  subscribe(){
    this.participantService.subscribe(this.notification.metaData.participantId).subscribe((data:any) => {
      if(data.hasError){
        return this.popupHelperService.printError();
      }
      if(data.data.message){
        this.eventManagerService.openTelegramModal();
      }else{
        this.popupHelperService.printSuccess();
      }
      this.NotificationModal.hide();
    })
  }

  delete(){
    this.meService.notificationDelete(this.notification._id).subscribe((data: any) =>{
      if (!data.hasError){
        this.notification = null
      }
    })
  }

  seen(notification:any){
    if(notification.status !== appConstants.NotificationStatus.SEEN){
      this.meService.notificationSeen(notification._id).subscribe((data: any) =>{
        if (!data.hasError){
          if (notification.status !== this.NotificationStatus.ACCEPTED && notification.status !== this.NotificationStatus.CANCELED){
            notification.status = this.NotificationStatus.SEEN
          }
        }
      })
    }
  }

  getDispute(){
    this.disputeService.getOneById(this.notification.metaData.disputesId).subscribe((data: any)=>{
      if(!data.hasError){
        this.disputeOne = data.data.disputeOne
      }
    })
  }

  openPopupSeen(not:any) {
    this.seen(not)
    this.eventManagerService.openNotificationModal(this.notification)
    // this.openModal.emit(this.notification);
  }



  closeNotificationModal(){
    this.meService.closeNotificationModal(this.notification._id).subscribe((data: any)=>{
    })
  }
  answerForQuestion(value: any){
    this.notificationService.answer(this.notification._id, {value}).subscribe((data: any)=>{
      if(!data.hasError){
        this.notification = data.data.notification
      }else {
        this.popupHelperService.printError(data.errorMessages[0].msg)
      }
    })
  }


  showConvertMoney(e:Event){
    this.closeNotifayModal.emit()
    this.eventManagerService.triggerConvertTicketsModal.emit();
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  goToTournamentPage(){
    if(this.notification.metaData.challengeId){
      this.router.navigate(['/tournaments/challenge/' + this.notification.metaData.challengeId])
    }
    this.closeNotifayModal.emit()
    this.closeNotifyWidget.emit()

  }
  goToOrderPage(){
    if(this.notification.metaData.orderId){
      this.router.navigate(['/marketplace/order/' + this.notification.metaData.orderId])
    }
    this.closeNotifayModal.emit()
    this.closeNotifyWidget.emit()

  }


  answerPublisherInvitationReq(status: string){
    this.publisherSettings.acceptAccount(this.notification._id, {status: status}).subscribe((data:any) => {
      if (!data.hasError) {
        this.popupHelperService.printSuccess()
        if(status === this.answersFriendReq.ACCEPTED){
          this.notification.status = this.NotificationStatus.ACCEPTED;
          this.router.navigate(['/publisher/'+ data.data.publisher._id + '/tournaments'])
        }else {
          this.notification.status = this.NotificationStatus.CANCELED;
        }
      } else {
        this.errorMessage = data.errorMessages[0].msg;
        this.popupHelperService.printError({text:this.errorMessage});
      }
    })
  }

}
